import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Script from "next/script";

import { Button, SVGSprite } from "@/components/Atoms";

import Typography from "@/foundation/Typography/V2";
import { clsx } from "@/utils";

import styles from "./ActionBannerSection.module.scss";

import data from "../data";

const ActionBannerSection = () => {
  const router = useRouter();

  const { primaryCTA, banner } = data.actions;
  const { text: primaryCTAText } = primaryCTA;
  const { prefix, heading, content } = banner;
  const { title, secondaryCTA } = content;
  const { text: secondaryCTAText } = secondaryCTA;

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const [showFloatingBanner, setShowFloatingBanner] = useState(false);

  useEffect(() => {
    const participateButton = document.getElementById(
      "whs-participate-form-button"
    );
    const footer = document.getElementById("footer");
    if (participateButton) {
      const observer = new IntersectionObserver(([e]) => {
        setShowFloatingBanner(!e.isIntersecting);
      });
      observer.observe(participateButton);
    }
    if (footer) {
      const observer = new IntersectionObserver(([e]) => {
        setShowFloatingBanner(!e.isIntersecting);
      });
      observer.observe(footer);
    }
  }, [setShowFloatingBanner]);

  return (
    <>
      <div className={styles.actionBannerSection}>
        <div className={clsx(styles.actionBannerSectionContainer, "container")}>
          <Button
            className={styles.actionButton}
            onClick={() =>
              router.push(`/whs2023/survey/${window.location.search}`)
            }
            id="whs-participate-form-button"
          >
            {primaryCTAText}
            <SVGSprite icon="icon-arrow-right" />
          </Button>
          <div className={styles.banner}>
            <Typography variant="paragraph4" className={styles.prefix}>
              {prefix}
            </Typography>
            <Typography variant="heading2" className={styles.heading}>
              {heading}
            </Typography>
            <div className={styles.content}>
              <Typography variant="heading3" className={styles.title}>
                {title}
              </Typography>
              <Script src="https://tally.so/widgets/embed.js" />
              {isFormSubmitted ? (
                <Button className={clsx(styles.actionButton, styles.submitted)}>
                  <SVGSprite icon="icon-whs-button-submit" />
                  Submitted
                </Button>
              ) : (
                <Button
                  className={clsx(styles.actionButton, styles.secondary)}
                  onClick={() => {
                    window.Tally.openPopup("mRd1Gd", {
                      layout: "modal",
                      width: 500,
                      autoClose: 200,
                      onSubmit: () => setIsFormSubmitted(true),
                    });
                  }}
                  id="whs-hr-form-button"
                >
                  {secondaryCTAText}
                  <SVGSprite icon="icon-arrow-right" />
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
      {showFloatingBanner && (
        <div className={styles.floatingBanner}>
          <Button
            className={styles.actionButton}
            onClick={() =>
              router.push(`/whs2023/survey/${window.location.search}`)
            }
            id="whs-floating-banner-button"
          >
            {primaryCTAText}
            <SVGSprite icon="icon-arrow-right" />
          </Button>
        </div>
      )}
    </>
  );
};

export default ActionBannerSection;
